import Icon, { HighlightIcon, IconTypes } from './CustomIcon';
import ErrorIcon from './ErrorIcon';
import VisitIcon from './VisitIcon';
import NeoIconWithPopoverAndTooltip from './NeoIconWithPopoverAndTooltip';
import IconWithPopover from './IconWithPopover';
import NeoIconWithPopover from './NeoIconWithPopover';

export default Icon;
export {
    Icon,
    HighlightIcon,
    IconTypes,
    IconWithPopover,
    NeoIconWithPopover,
    ErrorIcon,
    VisitIcon,
    NeoIconWithPopoverAndTooltip
};
